export default [
    {
        name: 'word',
        sortField: 'word',
        type: 'string',
        callback: 'similarKeyWord',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: '__slot:pos',
        sortField: 'pos',
        type: 'number',
        dataClass: 'ral pos',
        useInFilter: true,
    },
    {
        name: 'ws',
        sortField: 'ws',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        isDefault: true,
        useInFilter: true,
    },
    {
        name: 'wsk',
        sortField: 'wsk',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
        isDefault: true,
        engine: "yandex"
    },
    {
        name: 'kei',
        sortField: 'kei',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
        engine: "yandex",
        link: "//help.keys.so/faq#hfaq-post-1953",
    },
    {
        name: 'wizardscount',
        sortField: 'wizardscount',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true
    },
    {
        name: 'wizards',
        type: 'wizards',
        useInFilter: true,
        visible: false
    },
    {
        name: 'numwords',
        sortField: 'numwords',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'adscnt',
        sortField: 'adscnt',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'docs',
        sortField: 'docs',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'avbid',
        sortField: 'avbid',
        type: 'number',
        callback: 'currency',
        dataClass: 'ral avbid',
        useInFilter: true,
    },
    {
        name: 'serpf',
        sortField: 'serp',
        type: 'string',
        dataClass: 'ral',
        useInFilter: false,
    },
    {
        name: 'isgeo',
        type: 'bool',
        useInFilter: true,
        visible: false,
    },
    {
        name: 'isquest',
        type: 'bool',
        useInFilter: true,
        visible: false,
    },
    {
        name: 'nw',
        type: 'bool',
        useInFilter: true,
        visible: false,
    },
    {
        name: 'delta',
        type: 'number',
        useInFilter: true,
        visible: false,
    },
    {
        name: '__component:key-meta-data',
        dataClass: 'text-center',
        useInFilter: false,
    }
]
